export interface CityData {
  slug: string;
  name: string;
  isPrimary?: boolean;
  description: string;       // used in city-service page hero
  neighborhoods: string[];   // listed on zones page / city page
  localSeo: {
    titleContext: string;
    h1Context: string;
    intro: string;
    faqContext: string;
  };
}

export const cities: CityData[] = [
  {
    slug: "vieux-longueuil",
    name: "Vieux-Longueuil",
    isPrimary: true,
    description: "Nous desservons le Vieux-Longueuil, au cœur de Longueuil, avec des interventions adaptées aux maisons, copropriétés et commerces de l'arrondissement.",
    neighborhoods: ["Vieux-Longueuil", "Le Moyne", "Saint-Jean-Baptiste", "Jacques-Cartier"],
    localSeo: {
      titleContext: "Vieux-Longueuil et secteurs voisins",
      h1Context: "dans le Vieux-Longueuil et les quartiers voisins",
      intro: "Dans les maisons et commerces du Vieux-Longueuil, de Le Moyne ou de Jacques-Cartier, nous adaptons l'intervention à l'accès, au réseau en place et aux symptômes observés.",
      faqContext: "Nous couvrons le Vieux-Longueuil, au cœur de Longueuil, ainsi que Le Moyne, Saint-Jean-Baptiste et Jacques-Cartier; indiquez votre secteur pour que nous préparions l'intervention.",
    },
  },
  {
    slug: "saint-hubert",
    name: "Saint-Hubert",
    description: "Nous intervenons à Saint-Hubert, de la base militaire aux quartiers résidentiels autour du boulevard Cousineau, ainsi que dans les secteurs Est et Ouest.",
    neighborhoods: ["Centre Saint-Hubert", "Secteur Est", "Secteur Ouest", "Bord de l'eau"],
    localSeo: {
      titleContext: "secteurs Est, Ouest et boulevard Cousineau",
      h1Context: "des quartiers Est et Ouest au boulevard Cousineau",
      intro: "À Saint-Hubert, nous nous déplaçons du Centre Saint-Hubert aux secteurs Est et Ouest, en tenant compte de l'emplacement des appareils et de l'accès à la plomberie.",
      faqContext: "Notre équipe dessert le Centre Saint-Hubert, les secteurs Est et Ouest ainsi que les environs du boulevard Cousineau; votre adresse aide à confirmer le délai et l'équipement.",
    },
  },
  {
    slug: "greenfield-park",
    name: "Greenfield Park",
    description: "Notre équipe couvre Greenfield Park, des secteurs résidentiels Notre-Dame et Mountainview aux commerces près du boulevard Taschereau.",
    neighborhoods: ["Centre Greenfield Park", "Secteur Notre-Dame", "Secteur Mountainview"],
    localSeo: {
      titleContext: "Notre-Dame, Mountainview et Taschereau",
      h1Context: "de Notre-Dame à Mountainview",
      intro: "À Greenfield Park, nous intervenons dans les secteurs Notre-Dame et Mountainview comme près du boulevard Taschereau, avec une approche adaptée au type de bâtiment et au problème observé.",
      faqContext: "Nous couvrons les secteurs Notre-Dame, Mountainview et le centre de Greenfield Park; décrivez les appareils touchés afin que nous préparions la bonne méthode.",
    },
  },
  {
    slug: "saint-lambert",
    name: "Saint-Lambert",
    description: "Nous desservons Saint-Lambert, du Vieux-Saint-Lambert aux secteurs Riverside et Station, jusque dans les quartiers près du fleuve Saint-Laurent.",
    neighborhoods: ["Vieux-Saint-Lambert", "Secteur Riverside", "Secteur Station"],
    localSeo: {
      titleContext: "Vieux-Saint-Lambert, Riverside et Station",
      h1Context: "du Vieux-Saint-Lambert au secteur Station",
      intro: "À Saint-Lambert, nous évaluons la situation dans les maisons du Vieux-Saint-Lambert, de Riverside et du secteur Station afin de proposer une intervention cohérente avec votre installation.",
      faqContext: "Nous desservons le Vieux-Saint-Lambert, Riverside et le secteur Station; précisez les symptômes et l'accès au local concerné pour recevoir une réponse adaptée.",
    },
  },
];

// These towns already appear in the service area. Project services get local
// pages here without expanding the established plumbing landing-page strategy.
export const additionalProjectCities: CityData[] = [
  { slug: "brossard", name: "Brossard" },
  { slug: "boucherville", name: "Boucherville" },
  { slug: "saint-bruno", name: "Saint-Bruno" },
  { slug: "la-prairie", name: "La Prairie" },
  { slug: "sainte-julie", name: "Sainte-Julie" },
  { slug: "candiac", name: "Candiac" },
  { slug: "carignan", name: "Carignan" },
  { slug: "saint-jean-sur-richelieu", name: "Saint-Jean-sur-Richelieu" },
].map(({ slug, name }) => ({
  slug,
  name,
  description: `Nous accompagnons vos projets de drainage et de rénovation à ${name}. Le périmètre des travaux, l'accès au chantier et les étapes sont précisés lors de l'évaluation.`,
  neighborhoods: [],
  localSeo: {
    titleContext: name,
    h1Context: `à ${name}`,
    intro: `Décrivez votre projet à ${name} pour préparer une évaluation adaptée au bâtiment et aux travaux souhaités.`,
    faqContext: "L'adresse, les photos de l'installation et les contraintes d'accès permettent de préparer l'évaluation.",
  },
}));

export const projectCities = [...cities, ...additionalProjectCities];
export const getServiceCities = (service: { category?: "projects" }) =>
  service.category === "projects" ? projectCities : cities;
export const getCity = (slug: string) => projectCities.find(c => c.slug === slug);
export const primaryCity = cities.find(c => c.isPrimary)!;
